import React from 'react';
import { Button } from 'antd';

export interface PosWorkspaceHeaderProps {
  isTopUpMode: boolean;
  canUseTopUp: boolean;
  hasBoxesRequiringClosure: boolean;
  onOperationChange: (isTopUp: boolean) => void;
  onOpenClosure: () => void;
}

export const PosWorkspaceHeader: React.FC<PosWorkspaceHeaderProps> = ({
  isTopUpMode,
  canUseTopUp,
  hasBoxesRequiringClosure,
  onOperationChange,
  onOpenClosure,
}) => (
  <div className="pos-screen__header">
    <h2 className="pos-screen__desktop-title">Venta Directa</h2>
    <div className="pos-screen__operation" role="group" aria-label="Tipo de operación">
      <button type="button" className={!isTopUpMode ? 'is-active' : ''} onClick={() => onOperationChange(false)}>
        Venta
      </button>
      <button
        type="button"
        className={isTopUpMode ? 'is-active' : ''}
        disabled={!canUseTopUp}
        onClick={() => onOperationChange(true)}
      >
        Saldo
      </button>
    </div>
    {hasBoxesRequiringClosure ? (
      <Button onClick={onOpenClosure} size="small" className="pos-screen__header-button" title="Cerrar cajas del día">
        Cierre de Caja
      </Button>
    ) : null}
  </div>
);

export default PosWorkspaceHeader;
